import React from "react";
import styles from "./kanban.module.css";
import { kanbanStatusToken, type KanbanBoardKind } from "./kanbanStatusTokens";

/**
 * Shared Kanban card chrome (Cortex Console Design System & Consistency
 * Pass, CCDS-01/02). Wraps the caller's existing per-card element - that
 * element keeps its own pre-existing data-testid, unchanged. `status`
 * selects the card's accent colour from the board's semantic-colour tokens
 * (CCDS-08); a status with no token (e.g. Agents' "complete" column) falls
 * back to the card's plain border, never a hardcoded hex.
 */
export type KanbanCardProps = {
  board: KanbanBoardKind;
  status?: string;
  children: React.ReactNode;
};

export function KanbanCard({ board, status, children }: KanbanCardProps) {
  const token = status ? kanbanStatusToken(board, status) : undefined;
  const style = token
    ? ({ borderInlineStartColor: `hsl(var(${token}))` } as React.CSSProperties)
    : undefined;
  return (
    <div className={styles.card} data-testid="kanban-card" style={style}>
      {children}
    </div>
  );
}
